(function () {
  function readConfig() {
    if (window.ytNavHighlights) return window.ytNavHighlights;

    var el = document.getElementById('yt-nav-highlights-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function itemMatchesTarget(item, target) {
    var matchHandle = normalizeHandle(item.match);
    var titleHandle = normalizeHandle(target.title);
    var navHandle = normalizeHandle(target.navHandle);
    var desktopTarget = normalizeHandle(target.desktopTarget);

    return (
      matchHandle === titleHandle ||
      matchHandle === navHandle ||
      matchHandle === desktopTarget ||
      String(item.match || '').trim().toLowerCase() === String(target.title || '').trim().toLowerCase()
    );
  }

  function findNavTargets() {
    var targets = [];
    var seen = new Set();

    document.querySelectorAll('[data-meganav-desktop-target]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      targets.push({
        el: el,
        title: el.querySelector('[data-nav-title]')?.textContent?.trim() || '',
        navHandle: el.getAttribute('data-meganav-nav-handle') || '',
        desktopTarget: el.getAttribute('data-meganav-desktop-target') || '',
      });
    });

    document.querySelectorAll('#mobile_menu > li[data-meganav-mobile-target]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      targets.push({
        el: el,
        title: el.querySelector('[data-nav-title]')?.textContent?.trim() || el.querySelector('.mobile-menu-item-title')?.textContent?.trim() || '',
        navHandle: el.getAttribute('data-meganav-nav-handle') || '',
        desktopTarget: el.getAttribute('data-meganav-mobile-target') || '',
      });
    });

    return targets;
  }

  function clearHighlight(el) {
    el.classList.remove('nav-menu-item--highlight', 'nav-menu-item--highlight-accent', 'nav-menu-item--highlight-badge');
    delete el.dataset.navHighlight;
    delete el.dataset.navBadge;
    delete el.dataset.navHighlightTarget;
    el.style.removeProperty('--nav-highlight-accent');
    el.querySelectorAll('.nav-menu-badge').forEach(function (badge) {
      badge.remove();
    });
  }

  function applyToElement(el, item, defaultColor) {
    clearHighlight(el);

    var color = item.color || defaultColor || '#a05862';
    el.classList.add('nav-menu-item--highlight', 'nav-menu-item--highlight-' + item.style);
    el.dataset.navHighlight = item.style;
    el.dataset.navHighlightTarget = normalizeHandle(item.match);
    el.style.setProperty('--nav-highlight-accent', color);

    if (item.style === 'badge') {
      el.dataset.navBadge = item.badgeText || 'New';
      var titleEl = el.querySelector('[data-nav-title]');
      if (titleEl) {
        var badge = document.createElement('span');
        badge.className = 'nav-menu-badge';
        badge.textContent = item.badgeText || 'New';
        titleEl.insertAdjacentElement('afterend', badge);
      }
    }
  }

  function applyNavHighlights() {
    var config = readConfig();
    if (!config || !config.enabled || !config.items || !config.items.length) return;

    document.querySelectorAll('.nav-menu-item--highlight, [data-nav-highlight]').forEach(clearHighlight);

    var targets = findNavTargets();

    config.items.forEach(function (item) {
      targets.forEach(function (target) {
        if (!itemMatchesTarget(item, target)) return;
        applyToElement(target.el, item, config.defaultColor);
      });
    });
  }

  window.applyNavHighlights = applyNavHighlights;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyNavHighlights);
  } else {
    applyNavHighlights();
  }

  document.addEventListener('shopify:section:load', applyNavHighlights);
  setTimeout(applyNavHighlights, 0);
  setTimeout(applyNavHighlights, 250);
  setTimeout(applyNavHighlights, 800);
  setTimeout(applyNavHighlights, 1600);
})();
